import { Injectable, EventEmitter } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "../utility/http.client";

@Injectable()
export class FileService {
  refreshHeaderData: EventEmitter<any> = new EventEmitter();

  constructor(private http: HttpClient) {}

  downloadFile(data: any): Observable<any> {
    return this.http.getFile("/files/get/", data);
  }
}
